import type { Company } from './models';

/** Mirrors `isPremiumAccessLapsed` in `lib/models/company_billing_plan.dart`. */
export function isPremiumAccessLapsed(company: {
  billingPlan?: string;
  premiumComplimentaryEndsAt?: Date;
  premiumSubscriptionPaidThrough?: Date;
  now?: Date;
}): boolean {
  const billingPlan = (company.billingPlan ?? 'premium').toLowerCase();
  if (billingPlan !== 'premium') return false;

  const now = company.now ?? new Date();
  const compEnd = company.premiumComplimentaryEndsAt;
  const paidThrough = company.premiumSubscriptionPaidThrough;

  const legacyUnlimitedPremium = compEnd == null && paidThrough == null;
  if (legacyUnlimitedPremium) return false;

  const hasComplimentaryAccess =
    compEnd != null && now.getTime() <= compEnd.getTime();
  const hasPaidSubscriptionAccess =
    paidThrough != null && now.getTime() <= paidThrough.getTime();

  return !(hasComplimentaryAccess || hasPaidSubscriptionAccess);
}

export function companyWorkspaceIsOnHold(company: Company): boolean {
  return isPremiumAccessLapsed(company);
}

/** True when Field Duty has unlimited access (Premium / Freemium, not on hold). */
export function fieldDutyAvailableForCompany(
  company: Company | null | undefined,
): boolean {
  if (!company) return false;
  const plan = (company.billingPlan ?? 'premium').toLowerCase();
  if (plan === 'free') return false;
  return !companyWorkspaceIsOnHold(company);
}

export {
  fieldDutyCanOpenForWorkspace,
  fieldDutyFeaturesActive,
  fieldDutyUnlimitedForWorkspace,
} from './fieldDutyTrial';
